(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/shared/customer-settings-service.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/shared/customer-settings-service.js');
'use strict';

const jupiter = svs.core.jupiter;

const getCustomersSettingsAsync = async function () {
  let c = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  let i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  svs.myProfile.logger.debug('CommunicationSettingsService:getCustomersSettingsAsync start...');
  try {
    var _rply$response, _rply$response4, _rply$response5;
    let path = '/player/1/settings';
    if (c !== '' && i !== '') {
      path = "/player/1/settings/guid?assignedKey=".concat(c, "&customerId=").concat(i);
    }
    const rply = await jupiter.callAsync({
      method: 'GET',
      path
    });
    if ((_rply$response = rply.response) !== null && _rply$response !== void 0 && _rply$response.error) {
      var _rply$response2, _rply$response3;
      svs.myProfile.logger.error('getCustomersSettingsAsync error response from jupiter:', (_rply$response2 = rply.response) === null || _rply$response2 === void 0 ? void 0 : _rply$response2.error);
      return {
        error: (_rply$response3 = rply.response) === null || _rply$response3 === void 0 ? void 0 : _rply$response3.error,
        settings: {}
      };
    }
    return {
      error: (_rply$response4 = rply.response) === null || _rply$response4 === void 0 ? void 0 : _rply$response4.error,
      settings: (_rply$response5 = rply.response) === null || _rply$response5 === void 0 ? void 0 : _rply$response5.settings
    };
  } catch (err) {
    svs.myProfile.logger.error('CommunicationSettingsService:getCustomersSettingsAsync error...', err);
    return {
      error: err,
      settings: {}
    };
  }
};

const putCustomersSettingsAsync = async function (settings) {
  let c = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  let i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  try {
    svs.myProfile.logger.debug("putCustomersSettingsAsync c: ".concat(c, ", i: ").concat(i));
    let path = '/player/1/settings';
    const data = {
      settings
    };
    if (c !== '' && i !== '') {
      path = '/player/1/settings/guid';
      data.assignedKey = c;
      data.customerId = i;
    }
    const _await$jupiter$callAs = await jupiter.callAsync({
        method: 'PUT',
        path,
        data
      }),
      response = _await$jupiter$callAs.response,
      status = _await$jupiter$callAs.status;
    if (status !== 'success') {
      svs.myProfile.logger.error('CommunicationSettingsService:setCustomersSettingsAsync error response from jupiter:', response.error);
      return {
        status,
        error: response.error
      };
    }
    svs.myProfile.logger.debug('CommunicationSettingsService:setCustomersSettingsAsync success response from jupiter');
    return {
      status,
      error: response.error
    };
  } catch (err) {
    svs.myProfile.logger.error('CommunicationSettingsService:setCustomersSettingsAsync errer from jupiter:', err);
    return {
      status: 'error',
      error: err
    };
  }
};
svs.myProfile.react.shared.customerSettingsService = {
  putCustomersSettingsAsync,
  getCustomersSettingsAsync
};

 })(window);